import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { GeotabLoginComponent } from './pages/geotab-login/geotab-login.component';
import { IframeLoginComponent } from './pages/iframe-login/iframe-login.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { UnauthorizedErrorPageComponent } from './pages/unauthorized-error-page/unauthorized-error-page.component';
import { IframeImplicitLoginComponent } from './pages/iframe-implicit-login/iframe-implicit-login.component';
import { RsaSsoLoginComponent } from './pages/rsa-sso-login/rsa-sso-login.component';
import { Auth0SsoLoginComponent } from './pages/auth0-sso-login/auth0-sso-login.component';
import { GeotabEulaComponent } from './pages/geotab-eula/geotab-eula.component';
import { TN3600SsoLoginComponent } from './pages/tn360-sso-login/tn360-sso-login.component';
import { OAuthLoginComponent } from './pages/oauth-login/oauth-login.component';

const routes: Routes = [
  {
    path: 'iframe-login',
    component: IframeLoginComponent,
    data: {
      removeSideNav: true,
    },
  },
  {
    path: 'geotab-eula',
    component: GeotabEulaComponent,
    data: {
      removeSideNav: true,
    },
  },
  {
    path: 'geotab-login',
    component: GeotabLoginComponent,
    data: {
      removeSideNav: true,
    },
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    data: {
      removeSideNav: true,
    },
  },
  {
    path: 'iframe-implicit-login',
    component: IframeImplicitLoginComponent,
    data: {
      removeSideNav: true,
    },
  },
  {
    path: 'rsa-sso-login',
    component: RsaSsoLoginComponent,
    data: {
      removeSideNav: true,
    },
  },
  {
    path: 'unauthorized-error',
    component: UnauthorizedErrorPageComponent,
    data: {
      removeSideNav: true,
    },
  },
  {
    path: 'auth0-sso-login',
    component: Auth0SsoLoginComponent,
    data: {
      removeSideNav: true,
    },
  },
  {
    path: 'tn360-sso-login',
    component: TN3600SsoLoginComponent,
    data: {
      removeSideNav: true,
    },
  },
  {
    path: 'oauth-login',
    component: OAuthLoginComponent,
    data: {
      removeSideNav: true,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class IframeAuthenticationRoutingModule {}
